import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const StackedArea = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	const optionsBar = {
		chart: {
			type: 'area'
		},
		title: {
			text: title,
			style: {
			  color: '#000',
			  fontSize: "14px",
			  fontWeight: "bold",
			}
		},
		yAxis: {
			title: {
				text: '매출액(백만원)'
			},
			labels: {
				formatter: function() {
					return Hightcharts.numberFormat(this.value, 0, '', ','); // 콤마 포맷
				}
			}
		},
		tooltip: {
			shared: true,
			headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
		},
		plotOptions: {
			series: {
				pointStart: 2018
			},
			area: {
				stacking: 'normal',
				lineColor: '#666666',
				lineWidth: 1,
				marker: {
					lineWidth: 1,
					lineColor: '#666666'
				}
			}
		},
		series: chartData
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} containerProps={{ style: { width:'100%' ,height: "90%" } }}/>
		</>
	);
};

export default StackedArea;